<div class="custom-select-wrapper">
  <p-multiSelect
    optionLabel="name"
    id="roleTypes"
    name="roleTypes"
    [options]="roles()"
    [placeholder]="'$select_role$' | translate"
    [(ngModel)]="selectedRoles"
    (onChange)="onRoleChange($event)">
    <ng-template let-roles pTemplate="selectedItems">
      @for (role of roles; track role) {
        <div>
          {{ role.name | translate }}
        </div>
      }
    </ng-template>
    <ng-template let-role pTemplate="item">
      {{ role.name | translate }}
    </ng-template>
  </p-multiSelect>
</div>
